// Format a booking id as EASY-XXXXX (5-char slug from UUID, uppercased).
// Matches backend `utils.confirmation.format_confirmation` exactly.
export function formatConfirmation(bookingId) {
  if (!bookingId) return "";
  const slug = String(bookingId).replace(/-/g, "").slice(0, 5).toUpperCase();
  return `EASY-${slug}`;
}

// Given a booking object, prefer the stored confirmation_number (if backend
// already computed it) and fall back to deriving from `id`.
export function getConfirmation(booking) {
  if (!booking) return "";
  return booking.confirmation_number || formatConfirmation(booking.id);
}
